<script setup lang="tsx">
import { type StandardModuleAsset } from '@/models/api-generated'
import { useI18n } from 'vue-i18n'
import ResponsibleSelect from '../widgets/ResponsibleSelect.vue'

const _ = defineProps<{
	readonly?: boolean
}>()

const model = defineModel<StandardModuleAsset[]>({ required: true })

const { t } = useI18n()
</script>
<template>
	<div v-if="model.length" class="row pt-4">
		<div class="col-12">
			<h6>
				{{ t('module.responsiblesForAssets') }}
				<i class="bi bi-info-circle-fill text-muted ms-2" v-one-tooltip="t('module.responsibleInfoTooltip')"></i>
			</h6>
		</div>
		<hr class="mt-0" />
		<div class="row fw-bold">
			<div class="col">{{ t('module.associationName') }}</div>
			<div class="col text-center">{{ t('institution') }}</div>
			<div class="col text-end">{{ t('responsible') }}</div>
		</div>
		<div class="row mt-2" v-for="(assoc, index) in model" :key="assoc.id">
			<div class="col">{{ assoc.asset.name }}</div>
			<div class="col text-center">{{ assoc.instance.name }}</div>
			<div class="col text-end">
				<span v-if="readonly">{{ assoc.responsible?.label || '-' }}</span>
				<ResponsibleSelect v-else :id="'module-responsible-' + index" v-model="assoc.responsible" class="assoc-responsible" />
			</div>
		</div>
	</div>

	<div v-else class="d-flex flex-column text-center justify-content-center mt-4">
		<i class="bi bi-unlock-fill fs-5"></i>
		<p class="mb-0">{{ t('module.noConnectedAssets') }}</p>
		<p>{{ t('module.connectAssetHint') }}</p>
	</div>
</template>
